import { loadBeacon4PerformanceDashboard, loadBeacon4PerformanceTable, clearBeacon4PerformanceDashboard } from '../reducers/Beacon4PerformanceKpiDataReducer';
import {
	resetBeacon4HiddenSeries,
	setBeacon4PerfTableKpi,
	setBeacon4PerfAggregationMode,
} from '../reducers/Beacon4FiltersReducer';

// Builds the API payload. The two `*Override` knobs let us reuse this for the
// table-only reload, where either the KPI or the aggregation mode may differ
// from what the dashboard last used.
const buildParams = (filters, { kpiOverride, aggModeOverride } = {}) => {
	const p = {
		tech:            filters.perfTech,
		mainKpiKey:      kpiOverride     ?? filters.perfMainKpi,
		dateFrom:        filters.dateFrom,
		dateTo:          filters.dateTo,
		aggregation:     filters.aggregation,
		aggregationMode: aggModeOverride ?? filters.perfAggregationMode,
	};
	if (filters.side)    p.side    = filters.side;
	if (filters.polygon) p.polygon = filters.polygon;
	if (filters.jvid)    p.jvId    = filters.jvid;
	return p;
};

export const loadBeacon4PerformanceView = () => async (dispatch, getState) => {
	const filters = getState().beacon4Filters;
	if (!filters.perfTech || !filters.perfMainKpi) return;
	const params = buildParams(filters);
	dispatch(resetBeacon4HiddenSeries());
	// Apply resets the table's KPI back to the dashboard's Main KPI so the
	// two panels stay aligned right after the user presses Apply. Afterwards,
	// the user is free to pick another KPI in the table without re-running Apply.
	dispatch(setBeacon4PerfTableKpi(filters.perfMainKpi));
	// Charts + table loaded in parallel
	await Promise.all([
		dispatch(loadBeacon4PerformanceDashboard(params)),
		dispatch(loadBeacon4PerformanceTable(params)),
	]);
};

export const reloadBeacon4PerformanceView = () => (dispatch) => {
	dispatch(loadBeacon4PerformanceView());
};

// Reloads ONLY the aggregation table for a different KPI and/or aggregation
// mode (used by the table's own controls). The charts are untouched. Pass
// `{ kpiKey }` to change the KPI or `{ aggMode }` to change the grouping —
// either or both. The Redux state for whatever you pass is updated too, so the
// new selection persists across subsequent Apply presses (until Apply resets
// kpi back to the dashboard's main KPI, by design).
export const reloadBeacon4PerformanceTableOnly = ({ kpiKey, aggMode } = {}) => async (dispatch, getState) => {
	const filters = getState().beacon4Filters;
	if (!filters.perfTech) return;
	if (kpiKey)  dispatch(setBeacon4PerfTableKpi(kpiKey));
	if (aggMode) dispatch(setBeacon4PerfAggregationMode(aggMode));
	const params = buildParams(filters, { kpiOverride: kpiKey, aggModeOverride: aggMode });
	// Need at least a KPI to fetch — bail silently otherwise.
	if (!params.mainKpiKey) return;
	await dispatch(loadBeacon4PerformanceTable(params));
};

export const clearBeacon4PerformanceData = () => (dispatch) => {
	dispatch(clearBeacon4PerformanceDashboard());
};